import styled from 'styled-components';

export const MapSection = styled.section`
  .gm-bundled-control-on-bottom {
    top: 30px;
  }
`;

export const NeighborhoodListingsMapContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  margin-bottom: 60px;
`;
